import './style/index.less';
import CorpUrlLogin from './CorpUrlLogin';
export default CorpUrlLogin;
